<template>
    <div>
        <div class="main-content bg-white" v-if="$currentUser.role !== 'admin'">
            <span class="alert-danger">У вас нет доступа к этой странице.</span>
        </div>
        <div class="main-content bg-white" v-if="$currentUser.role == 'admin'">
            <div class="page-header">
                <h3 class="page-title">Настройки</h3>
            </div>
            <div class="row">
                <div class="col-lg-12">
                    <span>Разрешить вносить/изменять данные с:</span>
                    <span v-if="loaded">{{settings.edit_date | formatDate}}</span>
                    <i class="icon-fa icon-fa-edit" style="cursor: pointer" @click="edit"></i>
                    <datepicker input-class="form-control"
                                v-if="open"
                                class="date"
                                monday-first
                                :inline="true"
                                @selected="onDateChange"
                                v-model="settings.edit_date"
                                :language="ru"
                                placeholder="">
                    </datepicker>
                </div>
              <div class="col-lg-12">
                <span>Разрешить вносить/изменять расход в данных с:</span>
                <span v-if="loaded">{{settings.expense_edit_date | formatDate}}</span>
                <i class="icon-fa icon-fa-edit" style="cursor: pointer" @click="editExpense"></i>
                <datepicker input-class="form-control"
                            v-if="openExpense"
                            class="date"
                            monday-first
                            :inline="true"
                            @selected="onSettingsChange($event, 'expense_edit_date')"
                            v-model="settings.expense_edit_date"
                            :language="ru"
                            placeholder="">
                </datepicker>
              </div>
              <div class="col-lg-12">
                <span>Разрешить вносить/изменять доход в данных с:</span>
                <span v-if="loaded">{{settings.revenue_edit_date | formatDate}}</span>
                <i class="icon-fa icon-fa-edit" style="cursor: pointer" @click="editRevenue"></i>
                <datepicker input-class="form-control"
                            v-if="openRevenue"
                            class="date"
                            monday-first
                            :inline="true"
                            @selected="onSettingsChange($event, 'revenue_edit_date')"
                            v-model="settings.revenue_edit_date"
                            :language="ru"
                            placeholder="">
                </datepicker>
              </div>
            </div>
        </div>
    </div>
</template>
<script>
    import {ru} from '../../services/customLocaleDatepicker'
    import Datepicker from 'vuejs-datepicker'
    import SettingsService from '../../services/settingsDataService'
    import moment from 'moment'

    export default {
        name: 'settings',
        filters: {
            formatDate: function (value) {
                if (value) {
                    return moment(new Date(value)).locale('ru').format('D MMM YYYY')
                }
            }
        },
        components: {
            Datepicker: Datepicker,
            SettingsService: SettingsService
        },
        data() {
            return {
                settings: [],
                ru: ru,
                open: false,
                openExpense: false,
                openRevenue: false,
                loaded: false,
            }
        },
        methods: {
            getMainSetting() {
                this.loaded = false
                SettingsService.getMainSetting()
                    .then(function (settings) {
                        this.settings = settings
                        this.loaded = true
                    }.bind(this))
            },
            onDateChange(e) {
                if (this.settings) {
                    this.settings.edit_date = e
                    SettingsService.updateSettings(this.settings)
                        .then(function (settings) {
                            this.settings = settings
                            this.open = false
                        }.bind(this))

                }
            },
            onSettingsChange(e, name) {
                SettingsService.updateSetting(name, e)
                    .then(function (settings) {
                      this.settings = settings
                      this.openExpense = false
                      this.openRevenue = false
                    }.bind(this))
            },
            edit() {
                this.open = !this.open
            },
            editExpense() {
              this.openExpense = !this.openExpense
            },
            editRevenue() {
              this.openRevenue = !this.openRevenue
            }
        },
        beforeMount() {
            this.getMainSetting()
        },
    }
</script>
<style>

</style>



// WEBPACK FOOTER //
// resources/js/views/front/Settings.vue